import { render, staticRenderFns } from "./StyleDeleteModal.vue?vue&type=template&id=b12ea162&scoped=true&"
import script from "./StyleDeleteModal.vue?vue&type=script&lang=ts&"
export * from "./StyleDeleteModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b12ea162",
  null
  
)

export default component.exports